import { Grid, Group, Text } from "@mantine/core"
import { Loader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { GenerateAlertsResponseDto } from "~/gen/api"
import { AlertBox } from "~/pages/Brand/Home/components/DashboardAlerts/AlertBox"

type Props = {
  dashboardAlerts: GenerateAlertsResponseDto | undefined
  isLoading: boolean
  hasAlerts: boolean
}

export const DashboardAlerts = ({
  isLoading,
  dashboardAlerts,
  hasAlerts,
}: Props) => {
  const { t } = useTranslation(["home"])

  if (isLoading) {
    return <Loader fullPage />
  }

  if (!hasAlerts) {
    return (
      <Group justify="center" gap="sm">
        <Text fz="sm" style={{ textAlign: "center" }}>
          {t("notifications.empty.alerts")}
        </Text>
      </Group>
    )
  }

  return (
    <Grid>
      {dashboardAlerts?.alertValues.map((alertValue) => (
        <Grid.Col key={alertValue.alert.id} span={4} h="auto">
          <AlertBox alertValue={alertValue} />
        </Grid.Col>
      ))}
    </Grid>
  )
}
